<script setup lang="ts">
  // import { Analytics } from "@vercel/analytics/nuxt/runtime";
</script>

<template>
  <div>
    <!-- <Analytics mode="production" /> -->
    <!-- Canary disabled for the application cycle (9 Oct 2026). -->
    <!-- <ui-canary /> -->
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
